<template>
  <div
    id="app"
    :class="{
      'xxs': windowSize.size === 'xxs',
      'xs min-xxs min-xs': windowSize.size === 'xs',
      'sm min-xxs min-xs min-sm': windowSize.size === 'sm',
      'md min-xxs min-xs min-sm min-md': windowSize.size === 'md',
      'lg min-xxs min-xs min-sm min-md': windowSize.size === 'lg',
      'xl min-xxs min-xs min-sm min-md min-lg': windowSize.size === 'xl',
    }"
    style="height: 100%;"
    @click="onClick"
  >
    <!-- <TopScrollBanner v-if="isHome" /> -->

    <app-header v-if="!isEmbedded"></app-header>

    <div v-show="!initializing" style="position: relative">
      <div
        :style="[
          'position: relative; z-index: 0;',
          overlayStore.overlays.length && 'height: 0; overflow: hidden;',
        ].join(' ')"
      >
        <TopBanners />

        <SideBanners>
          <router-view style="max-width: 1140px; flex-grow: 1; width: 100%"></router-view>
        </SideBanners>

        <app-footer v-if="!isEmbedded"></app-footer>
      </div>

      <template v-if="!isEmbedded">
        <component
          v-for="(overlay, i) in overlayStore.overlays"
          :key="overlay.key"
          :is="overlay.component"
          :style="[
            'z-index: 0; grid-row-start: 1; grid-column-start: 1;',
            i !== overlayStore.overlays.length - 1 && 'height: 0; overflow: hidden;'
          ].join(' ')"
          @close="() => overlayStore.hideOverlay(overlay.key)"
        />
      </template>
    </div>

    <div v-show="loading || initializing" class="loader-wrapper">
      <loader v-if="initializing" />
    </div>

    <opt-in-modal v-if="showOptIn" @close="showOptIn = false" :config="optInConfig" />

    <confirm-newsletter-modal v-if="showConfirmNewsletter" @close="showConfirmNewsletter = false" />

    <alert v-model="showAlert" v-show="showAlert" :placement="windowSize.width < windowSize.sizes.xs ? 'top' : 'top-right'" :duration="alertConfig.duration || 2000" :type="alertConfig.type || 'success'" :dismissable="alertConfig.dismissable || false">
      <p class="margin-0" v-html="alertConfig.content ? alertConfig.content : '&nbsp'">{{alertConfig.content}}</p>
    </alert>
<!--
    <cookie-banner /> -->

    <!-- <pop-in-message></pop-in-message> -->

    <!-- <transition
      name="feedback-dialog-transition"
      :appear="true"
      :duration="150"
    >
      <FeedbackDialog
        v-if="feedbackDialogModule.state.showDialog"
        :options="{
          onSubmit: () => {
            feedbackDialogModule.state.showDialog = false
            feedbackDialogModule.storage.status.set('submitted')

            $root.trackEvent({
              eventCategory: 'Feedback',
              eventAction: 'Submit',
              eventLabel: $route.fullPath,
            })
          },

          onDismiss: () => {
            feedbackDialogModule.state.showDialog = false
            feedbackDialogModule.storage.status.set('dismissed')

            $root.trackEvent({
              eventCategory: 'Feedback',
              eventAction: 'Dismiss',
              eventLabel: $route.fullPath,
            })
          },
        }"
      />
    </transition> -->

    <LoginDialog />

    <LoginToFollowDialog />

    <!-- <LoginToShowContactDialog /> -->

    <LoginToShowCompanyDialog />

    <LoginToShowKeyfiguresDialog />

    <ConfirmEmailSentDialog />

    <ExternalLoginWelcomeDialog />

    <ForgotPasswordDialog />

  </div>
</template>

<script>
import Vue from 'vue'
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Loader from '@/components/Loader'
import OptInModal from '@/components/OptInModal'
//import PopInMessage from '@/components/PopInMessage'
// import CookieBanner from '@/components/CookieBanner'
import ConfirmNewsletterModal from '@/components/ConfirmNewsletterModal'
import FeedbackDialog from 'vue-lasso-core/components/FeedbackDialog'
import LoginDialog from '@/components/LoginDialog.vue'
import LoginToFollowDialog from '@/components/LoginToFollowDialog.vue'
// import LoginToShowContactDialog from '@/components/LoginToShowContactDialog.vue'
import LoginToShowCompanyDialog from '@/components/LoginToShowCompanyDialog.vue'
import LoginToShowKeyfiguresDialog from '@/components/LoginToShowKeyfiguresDialog.vue'
import ConfirmEmailSentDialog from '@/components/ConfirmEmailSentDialog/ConfirmEmailSentDialog.vue'
// import EmailConfirmationExpiredDialog from '@/components/EmailConfirmationExpiredDialog/EmailConfirmationExpiredDialog.vue'
// import EmailConfirmedDialog from '@/components/EmailConfirmedDialog/EmailConfirmedDialog.vue'
import ExternalLoginWelcomeDialog from '@/components/ExternalLoginWelcomeDialog/ExternalLoginWelcomeDialog.vue'
// import EditProfileDialog from '@/components/EditProfileDialog/EditProfileDialog.vue'
// import ChangePasswordDialog from '@/components/ChangePasswordDialog/ChangePasswordDialog.vue'
// import DeleteAccountDialog from '@/components/DeleteAccountDialog/DeleteAccountDialog.vue'
import ForgotPasswordDialog from '@/components/ForgotPasswordDialog/ForgotPasswordDialog.vue'
// import ResetPasswordDialog from '@/components/ResetPasswordDialog/ResetPasswordDialog.vue'
// import LassoFreemiumSurveyDialog from '@/components/LassoFreemiumSurveyDialog.vue'
// import AppAdBanners from '@/components/AdBanners/AppAdBanners.vue'
import SideBanners from '@/components/AdBanners/SideBanners.vue'
import TopBanners from '@/components/AdBanners/TopBanners.vue'
// import TopScrollBanner from './components/TopScrollBanner.vue'
import feedbackDialogModule from '@/modules/feedback-dialog'
import userStore from '@/modules/users/store'
import windowSize from '@/window-size'
import { EventBus, Cookie, apiUrl } from '@/assets/js/helpers.js'

import Lists from '@/assets/js/lists.js'
import { alert } from 'vue-strap'
import overlayStore from '@/modules/overlays/store'
import { initBrandingSurvey } from './modules/branding-survey'

export default {
  name: 'app',

  components: {
    AppHeader,
    AppFooter,
    Loader,
    OptInModal,
    alert,
    //PopInMessage,
    ConfirmNewsletterModal,
    // CookieBanner,
    FeedbackDialog,
    LoginDialog,
    LoginToFollowDialog,
    // LoginToShowContactDialog,
    LoginToShowKeyfiguresDialog,
    ConfirmEmailSentDialog,
    // EmailConfirmationExpiredDialog,
    // EmailConfirmedDialog,
    ExternalLoginWelcomeDialog,
    // EditProfileDialog,
    // ChangePasswordDialog,
    // DeleteAccountDialog,
    ForgotPasswordDialog,
    // ResetPasswordDialog,
    // LassoFreemiumSurveyDialog,
    SideBanners,
    TopBanners,
    LoginToShowCompanyDialog
},

  data () {
    return {
      loading: false,
      initializing: true,
      showOptIn: false,
      optInConfig: null,
      showAlert: false,
      alertConfig: {},
      showConfirmNewsletter: false,

      windowSize,
      userStore,
      feedbackDialogModule,
      overlayStore,
    }
  },

  computed: {
    isEmbedded: function () {
      // return this.$route.query.embedded === 'true'
      try {
        return window.self !== window.top
      } catch (e) {
        return true
      }
    },
    isHome: function () {
      return this.$route.name === 'home'
    }
  },

  methods: {
    onClick: function (event) {
      EventBus.$emit('app-click', event)
    },

    openOptInModal (token) {
      EventBus.$emit('alert', { type: 'success', content: 'Et øjeblik..', duration: 5000 })
      this.$store.dispatch('getFollowed', token).then(followed => {
        this.showOptIn = true
        this.optInConfig = { ...followed, token }
      })
    },

    subscribeNewsletter (config) {
      this.$store.dispatch('confirmNewsletter', config).then(() => {
        this.showConfirmNewsletter = true
      })
    },
  },
  mounted: function () {
    var that = this
    var didScroll = false

    window.addEventListener('scroll', function () { didScroll = true })

    window.setInterval(() => {
      if (didScroll) {
        didScroll = false
        EventBus.$emit('scrolled')
      }
    }, 100)

    this.$router.beforeEach((to, from, next) => {
      that.loading = true
      EventBus.$emit('loading', { to, from, isLoading: true })
      next()
    })

    this.$router.afterEach((to, from) => {
      setTimeout(() => {
        // if (to.fullPath !== from.fullPath) window.scrollTo(0, 0)
        that.loading = false
        that.initializing = false
      })
    })

    EventBus.$on('alert', function (config) {
      that.showAlert = true
      that.alertConfig = config
    })

    // afterEach event is not fired on frontpage, therefore we have this, fired from "home"
    EventBus.$on('frontLoaded', function () {
      that.initializing = false
    })

    EventBus.$on('loading', function ({ to, from, isLoading }) {
        that.loading = isLoading
    })

    // listen for filled and unfilled ads and broadcast it.
    document.addEventListener("filledAd", e => EventBus.$emit('filledAd', e.detail.divId), false)
    document.addEventListener("unfilledAd", e => EventBus.$emit('unfilledAd', e.detail.divId), false)

    initBrandingSurvey()
  },

  watch: {
    '$route': function (route) {
      if (route.query.optIn) {
        this.openOptInModal(route.query.optIn)
        this.$router.replace({ name: route.name, params: route.params, query: {} })
      }

      if (route.query.newsletter) {
        this.subscribeNewsletter({ email: route.query.e, name: route.query.n, company: route.query.c })
        this.$router.replace({ name: route.name, params: route.params, query: {} })
      }

      var pageTitle = 'Lasso.dk'
      var metaDescription = 'Hold dig opdateret om alt, hvad der sker i dansk erhvervsliv! Her kan du se robotgenererede nyheder om alle danske virksomheder – skabt på offentlig data.'
      var imageUrl = 'https://lassox.com/assets/img/lasso-x_logo_1200x630.png'
      var ent

      switch (route.name) {
        case 'companyStory':
          var story = this.$store.state.stories[route.params.storyId]
          pageTitle = story.prettyHeadline
          metaDescription = Vue.filter('metaDescription')(Vue.filter('linkify')(story.content, true))
          imageUrl = (story.imageId || '').replace('.jpg', '_1200.jpg')
          break

        case 'company':
          ent = this.$store.state.entities[route.meta.lassoIdPrefixes + route.params.id]
          pageTitle = ent.company.name + ' - ' + ent.company.city + ' - ' + 'Regnskaber, roller og erhvervsnyheder'
          metaDescription = 'Få den seneste information om ' + ent.company.name + '. Se regnskaber, erhvervsnyheder, kontaktinfo, bestyrelse, direktion, ejere mm. om alle danske virksomheder, her på Lasso.dk.'
          break

        case 'person':
          ent = this.$store.state.entities[route.meta.lassoIdPrefixes + route.params.id]
          pageTitle = ent.person.firstName + (ent.person.lastName ? ' ' + ent.person.lastName : '') + ' - Roller i dansk erhvervsliv'
            metaDescription = 'Se alt om ' + pageTitle + ' i dansk erhvervsliv. Se roller i bestyrelser, direktioner og ejerskaber mm. om alle personer i dansk erhvervsliv, her på Lasso.dk'
            imageUrl = apiUrl + "/entity/" + route.meta.lassoIdPrefixes + route.params.id + "/images/resume.png"
          break

        case 'list':
          var list = Lists[route.params.listName]
          if (list) {
            pageTitle = list.title
            metaDescription = 'Nyheder i kategorien ' + list.title + '. ' + metaDescription
          }
          break
      }

      document.title = pageTitle

      for (var tag of [...document.head.getElementsByClassName('meta-description')]) {
        tag.setAttribute('content', metaDescription)
      }

      for (var tag2 of [...document.head.getElementsByClassName('meta-title')]) {
        tag2.setAttribute('content', pageTitle)
      }

      for (var tag3 of [...document.head.getElementsByClassName('meta-image')]) {
        tag3.setAttribute('content', imageUrl)
      }

      setTimeout(function () {
        var attr = document.getElementById('ogUrl')
        if (attr) attr.setAttribute('content', document.location.href)
        // dataLayer.push({ event: 'virtualPageview', virtualPageviewPath: document.location.pathname, virtualPageviewTitle: pageTitle })
      }, 10)
    },
  },
}
</script>

<style lang="less">
@import "~@oldShared/lasso/style/constants/colors";
@import "~@oldShared/lasso/style/spacing/margin";
@import "~@oldShared/lasso/style/spacing/padding";
@import "~@oldShared/lasso/style/utilities/mixin";
@import "~@oldShared/lasso/style/base/typography";
@import "~@oldShared/lasso/style/base/border";
@import "~@oldShared/lasso/style/base/shadow";
@import "~@oldShared/lasso/style/base/resume";
@import "~@oldShared/lasso/style/base/tooltip";

#search-input {
  height: 36px;
  border-radius: 2px;
  &.focused {
    border-radius: 2px 2px 0 0;
  }
}

.loader-wrapper {
  background-color: rgba(255, 255, 255, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.xxs, .xs {
  #search-input.focused {
    border-radius: 2px;
  }
  .router-link-active, .right{
    &.focused {
      width: 0;
    }
  }
  & #results-dropdown {
    margin-top: 13px;
  }
  #result-list .v-bar-inner {
    max-height: 320px;
  }
}
.sm {
  #searchBar {
    position: relative;
  }
  .right{
    &.focused {
      width: 0;
    }
  }
}

.clickable {
  cursor: pointer;
}

/* Bootstrap breakpoints for xxs */
//.col-xxs-1,.col-xxs-2,.col-xxs-3,.col-xxs-4,.col-xxs-5,.col-xxs-6,.col-xxs-7,.col-xxs-8,.col-xxs-9,.col-xxs-10,.col-xxs-11,.col-xxs-12{min-height:1px;padding-left:15px;padding-right:15px;position:relative}@media(max-width:479px){.col-xxs-1,.col-xxs-2,.col-xxs-3,.col-xxs-4,.col-xxs-5,.col-xxs-6,.col-xxs-7,.col-xxs-8,.col-xxs-9,.col-xxs-10,.col-xxs-11,.col-xxs-12{float:left}.col-xxs-12{width:100%}.col-xxs-11{width:91.66666667%}.col-xxs-10{width:83.33333333%}.col-xxs-9{width:75%}.col-xxs-8{width:66.66666667%}.col-xxs-7{width:58.33333333%}.col-xxs-6{width:50%}.col-xxs-5{width:41.66666667%}.col-xxs-4{width:33.33333333%}.col-xxs-3{width:25%}.col-xxs-2{width:16.66666667%}.col-xxs-1{width:8.33333333%}.col-xxs-pull-12{right:100%}.col-xxs-pull-11{right:91.66666667%}.col-xxs-pull-10{right:83.33333333%}.col-xxs-pull-9{right:75%}.col-xxs-pull-8{right:66.66666667%}.col-xxs-pull-7{right:58.33333333%}.col-xxs-pull-6{right:50%}.col-xxs-pull-5{right:41.66666667%}.col-xxs-pull-4{right:33.33333333%}.col-xxs-pull-3{right:25%}.col-xxs-pull-2{right:16.66666667%}.col-xxs-pull-1{right:8.33333333%}.col-xxs-pull-0{right:auto}.col-xxs-push-12{left:100%}.col-xxs-push-11{left:91.66666667%}.col-xxs-push-10{left:83.33333333%}.col-xxs-push-9{left:75%}.col-xxs-push-8{left:66.66666667%}.col-xxs-push-7{left:58.33333333%}.col-xxs-push-6{left:50%}.col-xxs-push-5{left:41.66666667%}.col-xxs-push-4{left:33.33333333%}.col-xxs-push-3{left:25%}.col-xxs-push-2{left:16.66666667%}.col-xxs-push-1{left:8.33333333%}.col-xxs-push-0{left:auto}.col-xxs-offset-12{margin-left:100%}.col-xxs-offset-11{margin-left:91.66666667%}.col-xxs-offset-10{margin-left:83.33333333%}.col-xxs-offset-9{margin-left:75%}.col-xxs-offset-8{margin-left:66.66666667%}.col-xxs-offset-7{margin-left:58.33333333%}.col-xxs-offset-6{margin-left:50%}.col-xxs-offset-5{margin-left:41.66666667%}.col-xxs-offset-4{margin-left:33.33333333%}.col-xxs-offset-3{margin-left:25%}.col-xxs-offset-2{margin-left:16.66666667%}.col-xxs-offset-1{margin-left:8.33333333%}.col-xxs-offset-0{margin-left:0}}@media(max-width:479px){.hidden-xxs{display:none !important}}.visible-xxs{display:none !important}.visible-xxs-block,.visible-xxs-inline,.visible-xxs-inline-block{display:none !important}@media(max-width:479px){.visible-xxs{display:block !important}table.visible-xxs{display:table}tr.visible-xxs{display:table-row !important}th.visible-xxs,td.visible-xxs{display:table-cell !important}.visible-xxs-block{display:block !important}.visible-xxs-inline{display:inline !important}.visible-xxs-inline-block{display:inline-block !important}}

html.noScroll {
  overflow-y: hidden;
  .zopim {
    display: none !important;
  }
}

body {
    font-size: 13px;
    line-height: 1.42857143;
    color: @text-primary;
    background: @background-primary;
}

[v-cloak] { display:none !important; }

p {
  margin: 0 0 10px;
  & b {
    font-weight: 500 !important;
    color: black !important;
  }
}

label {
  margin-bottom: 0;
}

button {
  &.btn {
    &.btn-outline-dark  {
      &:hover, &:not(:disabled):not(.disabled):active {
        background-color: #fff;
        color: #343a40;
      }
    }
  }
  &:focus, &:active {
    outline: none !important;
  }
}

.btn-primary {
  border-radius: 30px !important;
  font-weight: 500 !important;
  padding: 0 23px !important;
  height: 34px !important;
  display: inline-flex;
  align-items: center;
}

h1 {
  font-size: 35px;
  line-height: 1.15;
  word-wrap: break-word;
}

h2 {
  font-size: 25px;
  line-height: 1.15;
  word-wrap: break-word;
}

h3 {
  font-size: 22px;
  line-height: 1.15;
}

h4 {
  font-size: 18px;
}

input:active, input:focus {
  outline: none !important;
}

form.lasso-form {
  label {
    font-weight: 500;
    font-size: 14px;
    line-height: 14px;
    margin-bottom: 10px;
  }
  input.form-control, select.form-control, textarea.form-control {
    border-color: @form-lasso-input-form-control;
    border-radius: 2px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
    height: 42px;

    &:active, &:focus {
      box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.05);
    }
  }

  textarea.form-control {
    height: initial
  }

  select {
    &.text-muted {
      color: rgba(61, 61, 61, 0.6) !important
    }
  }

  .form-group {
    margin: 0;
    .form-control {
      font-size: 14px;
    }
  }

  .form-group + .form-group {
    margin-top: 20px;
  }
}

.alert.alert-success {
  padding: 15px 30px;
  background-color: @background-alert;
  top: 93px !important;
  max-width: 85%;
  color: #dedede;
  font-weight: 500;
  border: none;
  min-height: 48px;
  .close {
    color: #fff;
  }
}

.btn {
  border-radius: 2px;
  font-weight: bold;
  font-size: 14px;
  &:active {
    box-shadow: inset 0 3px 5px rgba(0,0,0,.125);
  }

  &.btn-default {
    &:hover {
      background-color: #fff;
    }
  }

  &.btn-shadow {
    .box-shadow-public-site
  }

  &.btn-shadow-hover:hover {
    .box-shadow-public-site
  }

  &.btn-md {
    height: 36px;
    padding: 0 15px;
    line-height: 35px;
    font-size: 11px;

    .btn-icon {
      position: relative;
      top: -1px;
      margin-right: 15px;
    }
  }

  &.btn-discover {
    background: #fff;
    color: #222;

    i {
      font-size: 13px;
    }
    span {
      padding: 0 0 0 10px;
    }
  }

  &.btn-share {
    background: #fff;
    color: #222;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid #ebebeb;
    height: 34px;
    border-radius: 30px;
    line-height: 11px;
    padding: 9px 10px;

    img {
      width: 13px;
      height: 12px;
      margin-right: 10px;
    }
    &.dropdown-toggle::after {
      display: none !important;
    }
    span.caret {
      display: none !important;
    }
  }


  &.btn-primary {
    background-color: @red-primary;
    border-color: @red-primary;
    color: white;

    &:active, &:not(:disabled):not(.disabled):active, &:active:focus {
      background-color: @red-primary;
      border-color: @red-primary;
      box-shadow: 0 0 0 0 rgba(0,0,0,.0);
    }
  }
}

#app {
  position: relative;
  display: flex;
  flex-direction: column;

  &:not(.embedded) {
    padding-top: 80px;
  }

  &.embedded {
    .hide-when-embedded {
      display: none;
    }

    padding-bottom: 50px;

    .entity {
      margin-top: 0 !important;
      .news-feed-header {
        padding-top: 0 !important;
      }
    }
  }
}

#app {
  &.xxs {
    padding-top: 70px;
    .width-constraint {
      padding-left: 0;
      padding-right: 0;
    }

    .no-side-padding-xxs { padding-left: 0; padding-right: 0 }

    .content-box {
      border-radius: 0;
    }
  }

  &.xs {
    padding-top: 70px;
    .width-constraint {
      padding-left: 15px;
      padding-right: 15px;
    }

    #appHeader {
      .width-constraint {
        padding: 0;
      }
      &.focused .width-constraint {
        padding: 0 15px;
      }
    }
    .entity, #faq, #contact, #about {
      margin: 0 auto;
    }

    .no-side-padding-xs { padding-left: 0; padding-right: 0 }
  }

  &.sm {
    .width-constraint {
      padding-left: 30px;
      padding-right: 30px;
    }

    .no-padding-left-sm {
      padding-left: 0;
    }

    .no-padding-right-sm {
      padding-right: 0;
    }

    .no-side-padding-sm { padding-left: 0; padding-right: 0 }
  }

  &.md {
    .width-constraint {
      padding-left: 30px;
      padding-right: 30px;
    }

    .no-padding-left-md {
      padding-left: 0;
    }

    .no-padding-right-md {
      padding-right: 0;
    }
  }

  &.lg, &.xl {
    .width-constraint {
      width: @xl;
      max-width: @xl;
      padding-left: 30px;
      padding-right: 30px;
    }

    .no-padding-left-lg {
      padding-left: 0;
    }

    .no-padding-right-lg {
      padding-right: 0;
    }
  }

  /* sm and below */
  &.xxs, &.xs, &.sm {
    .container-fluid-responsive {
      padding-right: 30px;
      padding-left: 30px;
      margin-right: auto;
      margin-left: auto;
    }

    .gutter-responsive.row {
      margin-right: -30px;
      margin-left: -30px;
    }
    .gutter-responsive > [class^="col-"], .gutter-responsive > [class^=" col-"] {
      padding-right: 30px;
      padding-left: 30px;
    }

    .entity, .story, #faq, #about, #contact {
      .content-box-padding {
        padding: 30px 0;
      }
    }

    .content-box-padding-x {
      padding-left: 30px;
      padding-right: 30px;
    }

    .content-box-padding-y {
      padding-top: 30px;
      padding-bottom: 30px;
    }
  }

  /* xs and up */
  &.xs, &.sm, &.md, &.lg, &.xl {
    .no-padding-left-min-xs { padding-left: 0 }
    .no-padding-right-min-xs { padding-right: 0 }

    .content-box {
      border-radius: 20px;
      &.news-preview .image {

          border-radius: 20px 20px 0 0;

      }
    }
  }

  /* sm and up */
  &.sm, &.md, &.lg, &.xl {
    .no-padding-left-min-sm { padding-left: 0 }
    .no-padding-right-min-sm { padding-right: 0 }

    .entity, #contact, #faq, #about, #job, #profile {
      margin: 0 auto;
    }
  }

  /* md and up */
  &.md, &.lg, &.xl {
    .no-padding-left-min-md { padding-left: 0 }
    .no-padding-right-min-md { padding-right: 0 }

    .container-fluid-responsive {
        padding-right: 60px;
        padding-left: 60px;
        margin-right: auto;
        margin-left: auto;
    }

    .gutter-responsive.row {
      margin-right: -60px;
      margin-left: -60px;
    }
    .gutter-responsive > [class^="col-"], .gutter-responsive > [class^=" col-"] {
      padding-right: 60px;
      padding-left: 60px;
    }

    .entity, .story, .account-viewer {
      .content-box-padding {
        padding: 50px 0;
      }
    }

    .content-box-padding-x {
      padding-left: 60px;
      padding-right: 60px;
    }

    .content-box-padding-y {
      padding-top: 60px;
      padding-bottom: 60px;
    }
  }

  /* xl */
  &.xl {
    .no-padding-left-xl { padding-left: 0 }
    .no-padding-right-xl { padding-right: 0 }
  }
}

.row.is-flex {
    display: flex;
    flex-wrap: wrap;
}
.row.is-flex > [class*='col-'] {
    display: flex;
    flex-direction: column;
}

.row.is-flex {
    display: flex;
    flex-wrap: wrap;
}

.row.is-flex > [class*='col-'] {
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    flex-direction: column;
}

.entity, .story {
  .btn-copy {
    height: 20px;
    vertical-align: text-bottom;
    margin-left: 5px;
    font-size: 10px;
    padding: 0 6px;
    color: #FF8E61;
    border-color: #dfdfdf;
  }

  .key-figures {
    .key-figure {
      font-weight: 500;
      text-align: center;
      padding-bottom: 30px;
      padding-top: 15px;
      h3 {
        margin: 0 0 8px 0;
      }
    }
  }
}

.content-box {
  border-radius: 3px;
  background-color: #fff;
  font-size: 15px;
  .box-shadow;
}

.help-box {
  background-color: #f8f8f8;
  padding: 25px 30px;
  .title {
    font-size: 11px;
    font-weight: 700;
  }
  p {
    margin: 15px 0 0 0;
    font-weight: 14px;
    line-height: 23px;
  }
}

.load-news {
  cursor: pointer;
  border: 1px solid #dedede;
  &:hover {
      border: 1px solid #dadada;
      text-decoration: underline;
    }
  }

.filetype {
  cursor: pointer;
  border-radius: 2px;
  font-weight: 500;
  font-size: 7px;
  line-height: 7px;
  color: #fff;
  margin-right: 8px;
  padding: 3px 4px 2px 4px;
  position: relative;
  top: -3px;

  &.pdf { background-color: @red-primary; }
  &.tiff { background-color: #94C11A; }
  &.xml { background-color: #004180; }

  .notification {
    width: 12px;
    background: @red-primary;
    color: white;
    height: 12px;
    text-align: center;
    border-color: white;
    top: -7px;
    right: -7px;
    position: absolute;
    border-radius: 10px;
    border: 1px solid white;
    padding-top: 2px;
  }
}
</style>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600&display=swap');
@import '@shared/style/root.scss';
@import 'vue-lasso-core/style/root.scss';

a {
  color: #FF8E61;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    color: #FF8E61;
  }

  &:focus, &:active {
    color: #FF8E61;
  }

  &:not([href]):not([tabindex]) {
    color: white;

    &:hover {
      color: white;
    }
  }

  &.router-link-active {
    text-decoration: none;
    color: inherit;
    cursor: text;
  }
}

#app {
  overflow: visible;

  .dialog-root > .dialog {
    border-radius: 8px;
  }

  .checkbox {
    .custom-checkbox {
      .icon .md-icon.checked-icon {
        color: #FF8E61;
      }
    }

    .error {
      color: #ef4444;
    }
  }
}
</style>

<style lang="scss" scoped>
.feedback-dialog {
  z-index: 99999999;

  &.feedback-dialog-transition {
    &-enter-active,
    &-leave-active {
      transition: opacity 150ms linear;
    }

    &-enter,
    &-leave-to {
      opacity: 0;
    }

    &-leave,
    &-enter-to {
      opacity: 1;
    }
  }
}
</style>
